module.exports = __webpack_public_path__ + "img/across chest.8f82beb0.png";